import React, { useState } from "react";
import { SearchIcon, PlusIcon, Pencil, Trash, X } from "lucide-react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../styles/productStyles.css";
import { Box, Fab, Modal, TextField } from "@mui/material";
import SellasTable from "./SellAsTable";
import ViewPackModalTable from "./ViewPackModalTable";
import ProductSection from "./ProductSection";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 773,
  bgcolor: "background.paper",
  border: "2px solid #ffffff",
  boxShadow: 24,
  borderRadius: 2,
};

function createData(id, name, calories, fat, carbs, protein) {
  return { id, name, calories, fat, carbs, protein };
}

const SellViewtable = () => {
  const [rows, setrows] = useState([
    createData(0, "Black", 10, 12.255, 2),
    createData(1, "Black", 10, 12.255, 2),
    createData(2, "Black", 10, 12.255, 2),
    createData(3, "Black", 10, 12.255, 2),
    createData(4, "Black", 10, 12.255, 2),
    createData(5, "Black", 10, 12.255, 2),
  ]);

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const handleClose = () => setOpen(false);

  const deleteEmployee = id => {
    return setrows([...rows.filter(item => item.id !== id)]);
  };

  const [size, setsize] = useState("");
  const [Quantity, setquantity] = useState("");
  const [mrp, setmrp] = useState("");
  const [total, settoatal] = useState("");

  const handleAddRow = () => {
    const data = {
      id: rows.length + 1,
      name: size,
      calories: Quantity,
      fat: mrp,
      carbs: total,
    };

    if (size === "" || Quantity === "" || total === "" || mrp === "") return;
    else setrows([...rows, data]);

    setsize("");
    setquantity("");
    setmrp("");
    settoatal("");
  };

  const [add, setadd] = useState(true);
  const [edit, setedit] = useState(true);
  const [rowdata, setrowdata] = useState(0);

  return (
    <div className="flex flex-col box-border w-[100] border border-zinc-300 rounded-lg">
      <div className="flex flex-row box-border h-[8.7vh] w-[100] rounded-lg">
        <div className="w-[60%] box-border flex items-center px-[3.220338983%] justify-start text-[14px] font-medium outfit-semibold">
          Size & Color
        </div>
        <div className="w-[40%] h-[100%] mt-3 box-border flex flex-row items-start justify-end pr-2   ">
          <div className="ml-[0.69444vw] h-[60%] rounded-xl flex flex-row gap-x-2 items-center justify-center">
            <button
              className="text-sm flex flex-row text-[#ffffff] p-[0.27777vh] rounded-md shadow-md ring-black bg-[#ECE6F0] items-center justify-center"
              onClick={() => setOpen2(true)}>
              <Pencil
                color="#6750A4"
                size={20}
                className="mx-1 h-[19px] w-[19px]"
              />
            </button>
            <button
              className="text-sm flex flex-row text-[#ffffff] p-[0.27777vh] rounded-md shadow-md ring-black bg-[#ECE6F0] items-center justify-center"
              onClick={() => setOpen(!open)}>
              <Trash color="red" className="mx-1 h-[19px] w-[19px]" />
            </button>
          </div>
        </div>
      </div>

      <div className="flex flex-row box-border h-[45.64px] w-[100] pl-2">
        <img
          src={require("../../../../assets/shoes.png")}
          alt="Product image"
          className="w-[54px]"
        />
        <div className="w-[100%] flex items-start justify-start flex-col">
          <div className=" box-border flex items-center px-[3.220338983%] justify-start text-[14px] font-medium outfit-semibold">
            Rexene upper Regular Shoes
          </div>
          <p className=" box-border flex items-center px-[3.220338983%] justify-start text-[1.7031525vh] font-medium outfit-medium text-[#5652B0]">
            6 shoes
          </p>
        </div>
      </div>

      <hr className="border-[0.712px] border-zinc-400 w-[90%] mx-auto my-4" />

      <TableContainer
        sx={{ maxHeight: 320 }}
        className="overflow-y-scroll no-scrollbar">
        <Table
          sx={{ minWidth: 271.96 }}
          stickyHeader
          aria-label="sticky table"
          className="rounded-sm">
          <TableHead>
            <TableRow>
              <TableCell
                align="center"
                className="border-r-[1px] border-zinc-400 text-[13px] outfit-semibold"
                style={{ backgroundColor: "#EAEAEA" }}>
                Color
              </TableCell>
              <TableCell
                align="center"
                className="border-r-[1px] border-zinc-400 text-[13px] outfit-semibold"
                style={{ backgroundColor: "#EAEAEA" }}>
                Size
              </TableCell>
              <TableCell
                align="center"
                className="border-r-[1px] border-zinc-400 text-[13px] outfit-semibold"
                style={{ backgroundColor: "#EAEAEA" }}>
                Price(₹)
              </TableCell>
              <TableCell
                align="center"
                className="border-r-[1px] border-zinc-400  outfit-semibold"
                style={{ backgroundColor: "#EAEAEA" }}>
                Qty
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.name}>
                <TableCell
                  scope="row"
                  align="center"
                  className="border-r-[1px] border-zinc-400">
                  <div className="flex flex-row gap-x-3 items-center justify-center">
                    <div className="w-[15.41px] h-[15.41px] bg-black rounded-full outfit-regular"></div>
                    {row.name}
                  </div>
                </TableCell>
                <TableCell
                  align="center"
                  className="border-r-[1px] border-zinc-400 outfit-regular ">
                  {row.calories}
                </TableCell>
                <TableCell
                  align="center"
                  className="border-r-[1px] border-zinc-400 outfit-regular ">
                  {row.fat}
                </TableCell>
                <TableCell
                  align="center"
                  className="border-r-[1px] border-zinc-400 outfit-regular ">
                  {row.carbs}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style} className="rounded-xl">
          <div className="flex justify-between items-center flex-col">
            <div className="ml-[0.69444vw] w-[100%] px-4 py-2 h-[100%] rounded-full flex flex-row gap-x-2 items-end justify-end">
              <button
                onClick={handleClose}
                className="text-sm flex flex-row text-[#ffffff] px-1 py-1 rounded-full shadow-md ring-black bg-[#ECE6F0] items-center justify-center">
                <X color="#000" size={18} className="mx-1 h-[24px] w-[24px]" />
              </button>
            </div>
            <div className="w-[100%] flex items-center justify-center">
              <img
                src={require("../../../../assets/deletelogo.png")}
                alt="Successful Modal Icon"
                className="w-[8.42vw]"
              />
            </div>
            <div className="w-[100%] flex flex-col items-center justify-center mt-[4.167%]">
              <p className="font-outfit font-medium text-[20px] mx-10 my-2 text-center items-center">
                Are you sure you want to delete
              </p>
              <p className="font-outfit font-medium text-[20px] mx-10 my-2 text-center items-center">
                Product Name, Product Id?
              </p>
            </div>

            <div className="w-[100%] flex items-center my-[4.167%] justify-center gap-x-6">
              <button
                className="border-2 border-[#FF0000] rounded-md px-2 py-2 font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row"
                onClick={() => setOpen(false)}>
                {" "}
                <span className="px-3 text-[#5654B0]">Cancel</span>
              </button>
              <button
                className="border-2 border-[#5654B0] rounded-md px-2 py-2 font-medium font-outfit flex items-center justify-center flex-row bg-[#5654B0] cursor-pointer"
                onClick={() => setOpen(false)}>
                {" "}
                <span className="px-2 text-white flex flex-row items-center justify-center">
                  Delete
                </span>
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={open2}
        onClose={() => setOpen2(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="flex flex-row box-border w-full border-b-[0.5px] border-zinc-600 my-2">
            <div className="w-[60%] h-[100%] box-border flex items-center py-2 px-[3.220338983%] justify-start text-[20px] font-medium font-outfit">
              Edit
            </div>
            <div className="w-[40%] h-[100%] mt-2 box-border flex flex-row items-start justify-end pr-2">
              <div className="ml-[0.69444vw] h-[60%] rounded-xl flex flex-row gap-x-2 items-center justify-center">
                <button
                  onClick={() => setOpen2(false)}
                  className="text-sm flex flex-row text-[#ffffff] p-[3px] rounded-md shadow-md ring-black bg-[#ECE6F0] items-center justify-center">
                  <X
                    color="#000"
                    size={18}
                    className="mx-1 h-[18px] w-[18px]"
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="overlow-y-scroll no-scrollbar my-4">
            <div className="flex flex-row mt-4 items-start justify-start gap-x-3 mx-[2.52222vw]">
              <TextField
                id="outlined-basic"
                label="PCS"
                variant="outlined"
                color="secondary"
                size="small"
              />
            </div>

            <ProductSection data={"Pack Info"} />

            <TableContainer
              className="mx-[2.52222vw] mt-4 overflow-y-scroll no-scrollbar"
              sx={{ maxHeight: 320 }}>
              <Table
                sx={{ maxWidth: 640 }}
                stickyHeader
                aria-label="sticky table"
                className="rounded-sm">
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="center"
                      className="border-r-[1px] border-zinc-400 text-[13px] outfit-semibold"
                      style={{ backgroundColor: "#EAEAEA" }}>
                      Color
                    </TableCell>
                    <TableCell
                      align="center"
                      className="border-r-[1px] border-zinc-400 text-[13px] outfit-semibold"
                      style={{ backgroundColor: "#EAEAEA" }}>
                      Size
                    </TableCell>
                    <TableCell
                      align="center"
                      className="border-r-[1px] border-zinc-400 text-[13px] outfit-semibold"
                      style={{ backgroundColor: "#EAEAEA" }}>
                      Price(₹)
                    </TableCell>
                    <TableCell
                      align="center"
                      className=" outfit-semibold"
                      style={{ backgroundColor: "#EAEAEA" }}>
                      Qty
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map(row => (
                    <TableRow key={row.name}>
                      <TableCell
                        scope="row"
                        align="center"
                        className="border-r-[1px] border-zinc-400">
                        <div className="flex flex-row gap-x-3 items-center justify-center">
                          <div className="w-[15.41px] h-[15.41px] bg-black rounded-full outfit-regular"></div>
                          {row.name}
                        </div>
                      </TableCell>
                      <TableCell
                        align="center"
                        className="border-r-[1px] border-zinc-400 outfit-regular ">
                        {row.calories}
                      </TableCell>
                      <TableCell
                        align="center"
                        className="border-r-[1px] border-zinc-400 outfit-regular ">
                        {row.fat}
                      </TableCell>
                      <TableCell align="center" className="outfit-regular ">
                        {row.carbs}
                      </TableCell>
                      <TableCell
                        align="center"
                        className=" cursor-pointer"
                        style={{
                          display: edit === true ? "inline-block" : "none",
                        }}
                        onClick={() => {
                          setrowdata(row.name);
                          deleteEmployee(row.id);
                        }}>
                        <Trash color="red" size={18} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <div
            className={`mx-[2.52222vw] mt-4 flex items-center justify-center w-[90%]`}>
            <div className="w-[86%] flex flex-row">
              <div className="bg-[#F5F6F8] rounded-lg px-4 flex w-[32%] py-2 flex-row items-center h-[65%] allProductSearchBoxContainer ">
                <input
                  type="text"
                  placeholder="Enter Size..."
                  className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
                  value={size}
                  onChange={e => {
                    setsize(e.target.value);
                  }}
                />
              </div>
              <div className="bg-[#F5F6F8] rounded-lg py-2 px-2 flex w-[20%] mx-2 flex-row items-center h-[65%]  allProductSearchBoxContainer ">
                <input
                  type="text"
                  placeholder="Quantity..."
                  className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
                  value={Quantity}
                  onChange={e => {
                    setquantity(e.target.value);
                  }}
                />
              </div>
              <div className="bg-[#F5F6F8] rounded-lg py-2 px-2 flex w-[26%] flex-row items-center h-[65%]  allProductSearchBoxContainer ">
                <input
                  type="text"
                  placeholder="MRP (₹)..."
                  className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
                  value={mrp}
                  onChange={e => {
                    setmrp(e.target.value);
                  }}
                />
              </div>
              <div className="bg-[#F5F6F8] rounded-lg py-2 px-2 flex w-[22%] mx-2 flex-row items-center h-[65%]  allProductSearchBoxContainer">
                <input
                  type="text"
                  placeholder="Total Quantity..."
                  className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
                  value={total}
                  onChange={e => {
                    settoatal(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="mx-2 w-[16%] ">
              <button
                className="bg-[#5652B0] rounded-md px-6 py-2 text-[18px] font-medium font-outfit text-[#fff] flex items-center justify-center flex-row"
                onClick={handleAddRow}>
                Add
              </button>
            </div>
          </div>

          <hr className="border-[0.712px] border-zinc-200 w-[100%] mx-auto my-2" />

          <div className="flex flex-row mt-5 items-start justify-start mx-[1.522222vw] gap-x-3 pb-4">
            <button
              onClick={() => setOpen2(false)}
              className="border-[1px] border-zinc-300 rounded-md px-5 py-2 text-[2.2vh] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row">
              {" "}
              <span className="px- text-[#5652B0] px-3">Cancel</span>
            </button>
            <button
              onClick={() => setOpen2(false)}
              className="border-2 border-purple-700 rounded-md px-9 py-2 text-[2.2vh] font-medium font-outfit flex items-center justify-center flex-row bg-[#5652B0]">
              {" "}
              <span className="px-2 text-white ">Edit Pack</span>
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default SellViewtable;
